import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import './sidebar.css'
import logo from '../../../Images/login/Einstro Logo.png'
import dashboard from '../../../Images/icons/dashboard.svg'
import study from '../../../Images/icons/study.svg'
import note from '../../../Images/icons/blog.svg'
import course from '../../../Images/icons/course.svg'
import { SidebarData } from './SidebarData';
import { Tooltip, UncontrolledTooltip } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import request from '../../../api/api';
import { addPermission } from '../../../redux/login/login';



function Sidebar() {
  const dispatch = useDispatch()
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
   const [sidebarMenu, setSidebarMenu] = useState([]);
  const [activeMenu, setActiveMenu] = useState("");
  const location = useLocation();
  const admin = useSelector((state)=>state.admin.admin)
  const permissions = useSelector((state)=>state?.user?.permissions)??[]

  useEffect(() => {
    setSidebarMenu(SidebarData);
  }, []);

  useEffect(() => {
    const currentPath = location.pathname;
    const active = SidebarData.find((item) =>
      currentPath.startsWith(item.link)
    );
    if (active) {
      setActiveMenu(active.id);
    }
  }, [location]);

  const isAdmin = admin?.role === "admin";

const allowedSidebar = isAdmin
  ? SidebarData   // show everything
  : SidebarData.filter((li) => permissions?.includes(li?.link));


  return (
    <>
    <div className={`sidebar-top`}>
        <div className="logo">
          
        </div>
      </div>
    <section className={`sidebar`}>
    <ul className="sidebar-menu">
  {allowedSidebar.map((item) => (
    <li key={item.id} id={`menu-item-${item.id}`} onClick={() => setActiveMenu(item.id)}>
      <Link to={item.link} className="sb-link">
        <div className={`side-menu-box ${item.id === activeMenu ? "active" : ""}`}>
          <img src={item.img} alt={item.navItem} />
        </div>
      </Link>
      <UncontrolledTooltip
        placement="right"
        target={`menu-item-${item.id}`}
      >
        {item.navItem}
      </UncontrolledTooltip>
    </li>
  ))}
</ul>
  </section>
    </>
  )
}

export default Sidebar